import { Component, computed, contentChildren, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { SafeHtml } from '@angular/platform-browser';
import { RowActionDirective } from 'src/app/shared/directives/row-action.directive';
import { PassDataService } from 'src/app/shared/services/pass-data/pass-data.service';
import { PlatformService } from 'src/app/shared/services/platform.service';

// On a phone a single secondary action stays an icon; two or more go in the menu.
@Component({
  selector: 'urban-row-actions',
  templateUrl: './row-actions.component.html',
  styleUrl: './row-actions.component.scss',
  standalone: false,
  host: {
    '[class.uvRowActionsSingle]': 'secondaryCount() === 1'
  }
})
export class RowActionsComponent {
  protected readonly isMobile = inject(PlatformService).isMobileViewport;
  protected readonly icons = toSignal(inject(PassDataService).sanIcons$, { initialValue: {} as Record<string, SafeHtml> });
  protected readonly actions = contentChildren(RowActionDirective, { descendants: true });
  protected readonly secondaryCount = computed<number>(() => this.actions().filter((action: RowActionDirective) => !action.primary()).length);
  protected readonly hasMenu = computed<boolean>(() => this.secondaryCount() > 1);
}
